import axios from "axios";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import "./MyStyles.css";
import { faHouseUser } from "@fortawesome/free-solid-svg-icons";
import Badge from "@mui/material/Badge";
import NotificationsIcon from "@mui/icons-material/Notifications";
import CampaignIcon from "@mui/icons-material/Campaign";
import NewspaperIcon from "@mui/icons-material/Newspaper";    // 🗞️ news
import FeedIcon from "@mui/icons-material/Feed";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAuth } from "./context/AuthContext";

import { baseUrl, userName } from "./Univ.js";

function Header() {
  const { logoutUser } = useAuth();

  const isLoggedIn = localStorage.getItem("user_login") === "true";
  const userRole = localStorage.getItem("userGroup"); // Admin / District / BoothAgent

  const [reports, setReports] = useState([]);

  /* ---------------- FETCH DATA ---------------- */

  useEffect(() => {
    if (isLoggedIn) {
      fetchReports();

    }
  }, [isLoggedIn]);

  const fetchReports = async () => {
    try {
      const res = await axios.get(`${baseUrl}boothreports/`);
      setReports(res.data.filter(r => r.addedby === userName));
    } catch (err) {
      console.error(err);
    }
  };

  const unreadReports = reports.filter(r => r.status === 1);

  /* ---------------- LOGOUT ---------------- */

  const handleLogout = () => {
    logoutUser();
    window.location.href = "/user-login/";
  };


  return (
    <nav className="navbar navbar-expand-lg navbar-dark custom-navbar">
      <div className="container">

        <Link className="navbar-brand" to= "/">
          🗳️ VotersPulse TN
        </Link>

        {isLoggedIn && (
          <>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navMenu"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse" id="navMenu">

                <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                  <li className="nav-item">
                    <Link to="/admin-menu" className="nav-link">
                     <FontAwesomeIcon icon={faHouseUser} size="lg" style={{ color: "#ffc107" }} />
                     MENU
                    </Link>
                  </li>
                </ul>

              {/* RIGHT MENU */}
              <ul className="navbar-nav ms-auto align-items-center">


                {/* USER DROPDOWN */}
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                  >
                    {userName}
                  </a>

                  <ul className="dropdown-menu dropdown-menu-end">
                    <li>
                      <Link className="dropdown-item" to="/change-password">
                        Change Password
                      </Link>
                    </li>

                    <li>
                      <button className="dropdown-item" onClick={handleLogout}>
                        Logout
                      </button>
                    </li>
                  </ul>
                </li>

              </ul>
            </div>
          </>
        )}

        {!isLoggedIn && (
          <span className="navbar-text text-white">
            Election Operations Platform – Tamil Nadu
          </span>
        )}
      </div>
    </nav>
  );
}

export default Header;
